import { render, staticRenderFns } from "./DialogEditIncendio.vue?vue&type=template&id=24b882c0&scoped=true"
import script from "./DialogEditIncendio.vue?vue&type=script&lang=js"
export * from "./DialogEditIncendio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b882c0",
  null
  
)

export default component.exports